import { render, staticRenderFns } from "./CMenuPc.vue?vue&type=template&id=54d6b318&"
import script from "./CMenuPc.vue?vue&type=script&lang=ts&"
export * from "./CMenuPc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports